// source: http://stackoverflow.com/a/8809472
// source: http://stackoverflow.com/a/2117523
export function generateUUID() { // Public Domain/MIT
  let d = Date.now();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); //use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16); // eslint-disable-line  no-mixed-operators
  });
}


/** WEBPACK FOOTER **
 ** ./src/lib/UUID.js
 **/